import type { PreloadedQuery } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';
import QUERY, {
	type settingsSidebarPermissionQuery,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-common/src/common/ui/__generated__/settingsSidebarPermissionQuery.graphql';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';

export const nav4SidebarSettingsPageSwitcherResource: RouteResource<
	PreloadedQuery<settingsSidebarPermissionQuery>
> = createRelayResource<settingsSidebarPermissionQuery>({
	type: 'NAV4_SIDEBAR_SETTINGS_PAGE_SWITCHER',
	getQuery: (_routerContext, { tenantContext: { cloudId } }) => ({
		parameters: QUERY,
		variables: { cloudId },
		options: { fetchPolicy: 'store-and-network' as const },
	}),
	skip: (_routerContext, { tenantContext }) =>
		!fg('enable_jsm_admin') || tenantContext == null || tenantContext.isAdmin === true,
	captureErrors: true,
	isPageShellCritical: true,
});
